module.exports = __webpack_public_path__ + "assets/img/buy1.5044d676.png";